import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { GetBuyerListRequestDto } from "../dtos/get-buyer-list-request-dto";
import type { GetSalesDetailRequestDto } from "../dtos/get-sales-detail-request-dto";
import type { GetSalesListRequestDto } from "../dtos/get-sales-list-request-dto";
import type { GetSellerDetailRequestDto } from "../dtos/get-seller-detail-request-dto";
import type { GetSellerListRequestDto } from "../dtos/get-seller-list-request-dto";

export const UserQueryKeys = createQueryKeys("user", {
  getSalesList: ({ q, page, limit, sort }: GetSalesListRequestDto) => [
    q,
    page,
    limit,
    sort
  ],
  getSellerList: ({ q, page, limit, sort }: GetSellerListRequestDto) => [
    q,
    page,
    limit,
    sort
  ],
  getSellerDetail: ({ sellerId }: GetSellerDetailRequestDto) => [sellerId],
  getBuyerList: ({ q, page, limit, sort }: GetBuyerListRequestDto) => [
    q,
    limit,
    page,
    sort
  ],
  getBuyerDetail: (buyerId: string) => [buyerId],
  getSalesDetail: ({ salesId }: GetSalesDetailRequestDto) => [salesId],
  getUserCount: () => ["count"],
  getPicSalesList: (buyerId: string) => [buyerId]
});
